import script from "./AIGenerate.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIGenerate.vue?vue&type=script&setup=true&lang=ts"

import "./AIGenerate.vue?vue&type=style&index=0&id=d237c8dc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d237c8dc"]])

export default __exports__